import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'taskGroups' })
export class TaskGroupsPipe implements PipeTransform {
  transform(groups: any[]): any[] {
    if (!groups || !Array.isArray(groups)) return [];
    return groups.map(g => ({
      label: g.group || g.name || '',
      items: (g.items || []).map((item: any) => ({ value: item.name, label: item.name }))
    }));
  }
}